export const PROJECT_PROPERTY_KEY = 'connectedJswProject';

export const IS_CONNECTED_JSW_PROJECT_MIGRATED_KEY = 'isConnectedJswProjectMigrated';
